import * as React from 'react';

import { CORRECT_MATCHED, DEFAULT_FILL_IN_BLANK, Feedback, INSTRUCTIONS, REVISE_MATCHED, getAnswerState, getLatestAttempt } from '../../../Shared/index';
import { extractResponse } from '../../helpers/extractResponse';
import staticStrings from '../../../Shared/libs/speech/staticStrings.json';

class FeedbackComponent extends React.Component<any, any> {

  getFeedbackType(data?): string {
    if (data) {
      const wrappedAttempt = getLatestAttempt(data.question.attempts);
      const latestAttempt = extractResponse(wrappedAttempt);
      if (latestAttempt) {
        if (latestAttempt.feedback !== undefined) {
          const state = getAnswerState(wrappedAttempt);
          return state ? CORRECT_MATCHED : REVISE_MATCHED
        }
      } else {
        if (!!data.question.instructions) {
          return INSTRUCTIONS
        } else if (data.question.prompt.match(/___/g) && data.question.prompt.match(/___/g).length > 0) {
          return DEFAULT_FILL_IN_BLANK
        }
      }
    }
    return DEFAULT_FILL_IN_BLANK
  }

  getFeedbackText(data): string | undefined {
    switch (this.getFeedbackType(data)) {
      case REVISE_MATCHED:
      case CORRECT_MATCHED:
      case INSTRUCTIONS:
        return undefined
      case DEFAULT_FILL_IN_BLANK:
      default:
        return staticStrings['connect.defaultFillInBlankInstructions']
    }
  }

  getFeedbackHtml(data): string | undefined {
    const { question } = data;
    switch (this.getFeedbackType(data)) {
      case REVISE_MATCHED:
      case CORRECT_MATCHED:
        return getLatestAttempt(question.attempts).response.feedback
      case INSTRUCTIONS:
        return question.instructions
      default:
        return undefined
    }
  }

  render() {
    const { question, showTranslation, translate, latestAttempt, languageLocale } = this.props
    const key: number = question && question.attempts ? question.attempts.length : 0;
    if (question) {
      return (
        <Feedback
          feedbackHtml={this.getFeedbackHtml(this.props)}
          feedbackText={this.getFeedbackText(this.props)}
          feedbackType={this.getFeedbackType(this.props)}
          key={key}
          languageLocale={languageLocale}
          latestAttempt={latestAttempt}
          question={question}
          showTranslation={showTranslation}
          translate={translate}
        />
      )
    } else {
      return <span />
    }
  }
}

export default FeedbackComponent;
